import { BookATripMobileButton, BookATripPanel } from "@/components/organisms/BookATrip";
import { BookingHistoryTable } from "@/components/organisms/BookingHistory";
import { useCanManageAsAssistant } from "@/components/organisms/ClientHeader/ClientNavLinks";
import { YourDetailsSection } from "@/components/organisms/YourDetails";
import { PendingAssistantRequests } from "./PendingAssistantRequests";

/**
 * Client-portal landing (`/client`).
 *
 * Regular client — "Home": Book-a-Trip panel + their own details + their own booking history.
 * Executive Assistant / Travel Manager — "All Bookings": a full-width list of bookings MERGED across
 * every client they manage (BookingHistoryTable `managed` → Client column). No Book-a-Trip panel and
 * no details here (Book-a-Trip is the header button; the assistant's own details live on My Profile).
 */
export const ClientHome = () => {
  const isAssistant = useCanManageAsAssistant();

  if (isAssistant) {
    return (
      <div className="min-w-0 flex-1 overflow-y-auto px-3 py-6 pb-20 md:px-10">
        {/* Cap + centre so the table doesn't stretch full-width on ultrawide (no-op below 2360px).
            @container sits on the capped wrapper so its container queries measure the real width. */}
        <div className="@container mx-auto w-full max-w-[2360px]">
          <BookingHistoryTable managed />
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="flex h-full flex-1 overflow-hidden">
        {/* Left Panel — Desktop only */}
        <aside className="hidden h-full w-[473px] shrink-0 border-r border-neutral-mid-gray bg-white lg:block">
          <BookATripPanel />
        </aside>

        {/* Main Content */}
        <div className="min-w-0 flex-1 overflow-y-auto px-3 py-6 pb-20 md:px-10 lg:pb-6">
          {/* Cap + centre so content doesn't stretch full-width on ultrawide (no-op below 2360px).
              @container sits on the capped wrapper so Your Details' container queries measure it. */}
          <div className="@container mx-auto flex w-full max-w-[2360px] flex-col gap-10">
            {/* Client-only: the EA branch above never renders this. */}
            <PendingAssistantRequests />
            <YourDetailsSection />
            <BookingHistoryTable />
          </div>
        </div>
      </div>

      {/* Mobile/Tablet — Fixed bottom button */}
      <BookATripMobileButton />
    </>
  );
};
